export default () => import(/* webpackChunkName: 'coffee/app/download/coffee-hk' */ './HkCoffee');
